import { FormControl, Select, MenuItem, Checkbox, ListItemText, SelectChangeEvent } from "@mui/material";
import { FunctionComponent, useState } from "react";
import { DownloadXmlProperties, DownloadXmlProperty } from "../../Services/Properties";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const DownoaldXML: FunctionComponent<{ idProperty: any, toogle: any }> = (props) => {

    const [selectedPlatform, setSelectPlatform] = useState<any[]>([]);
    const [platforms, setPlatforms] = useState<any>([{ name: "Coralytics", src: "/assets/images/icons/coralytics.webp" }, { name: "Propstar", src: "/assets/images/icons/Logo-Properstar-main-RGB.webp" }, { name: "Propcrm", src: "/assets/images/icons/propcrm.png" }, { name: "Propertyfinder", src: "/assets/images/icons/finder.png" }, { name: "Bayut", src: "/assets/images/icons/bayut.png" }, { name: "Dubizzle", src: "/assets/images/icons/dubizzle.png" }]);
    const [isSpinner, setIsSpinner] = useState<boolean>(false);
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const handleClickOpen = () => {
        setSelectPlatform([]);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChangePlatforme = (event: SelectChangeEvent<typeof selectedPlatform>) => {
        const {
            target: { value },
        } = event;

        setSelectPlatform(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    /************Download Xml************ */

    const handleDownload = async () => {
        setIsSpinner(true)
        setOpen(false)
        if (props.idProperty) {
            for (let index = 0; index < selectedPlatform.length; index++) {
                const element = selectedPlatform[index];
                const xmldata = await DownloadXmlProperty([element], props.idProperty)
                const blob = new Blob([xmldata], { type: 'text/xml' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${"Properties_" + element}.xml`;
                a.click();
                URL.revokeObjectURL(url);
                if (index == selectedPlatform.length - 1) {
                    setSelectPlatform([])
                    setIsSpinner(false)
                }
            }
        } else {
            for (let index = 0; index < selectedPlatform.length; index++) {
                const element = selectedPlatform[index];
                const xmldata = await DownloadXmlProperties([element])
                const blob = new Blob([xmldata], { type: 'text/xml' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${"Properties_" + element}.xml`;
                a.click();
                URL.revokeObjectURL(url);
                if (index == selectedPlatform.length - 1) {
                    setSelectPlatform([])
                    setIsSpinner(false)
                }
            }
        }
    };


    return (<>
        <button type="button" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 padd-10-15-mb marg-right-16 mb-3" onClick={handleClickOpen} >
            {t('propertiesPage.download')}
            {isSpinner == true && <div className="spinner-border text-primary" role="status" style={{ marginLeft: "10px" }}>
                <span className="visually-hidden">Loading...</span>
            </div>}
        </button>


        <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            fullWidth={true}
            maxWidth={"sm"}
        >
            <DialogTitle id="customized-dialog-title">
                <div className="title-18 mt-2 "> {t('propertiesPage.titleDownload')}</div>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[800],
                    '&:hover': { backgroundColor: theme.palette.grey[400] }
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent >
                <div className="row padd-15">
                    <div className="col-md-12">
                        <label htmlFor="platform" className="para-16 mb-3"> {t('propertiesPage.selectPlatform')}</label>
                        <FormControl fullWidth>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                className="custom-select "
                                value={selectedPlatform}
                                onChange={handleChangePlatforme}
                                renderValue={(selected) => selected.join(', ')}>
                                {platforms.map((platform: any, index: any) => (
                                    <MenuItem value={platform.name} key={index}>
                                        <Checkbox checked={selectedPlatform.indexOf(platform.name) > -1} />
                                        <img src={platform.src} style={{ width: "auto", maxHeight: "20px", marginRight: "10px" }} />
                                        <ListItemText primary={platform.name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <button type="button" onClick={handleDownload} className={`button-dash back-746AFF color-FFFFFF  border-746AFF padd-15 marg-right-16" ${selectedPlatform.length == 0 ? "disabled" : ''}`}>    {t('propertiesPage.download')}</button>
                <button type="button" className="button-dash btn-outline-secondary back-trans padd-15" onClick={handleClose}>
                    {t('propertiesPage.close')}
                </button>
            </DialogActions>
        </BootstrapDialog>


    </>
    )
}
export default DownoaldXML;
